import * as React from 'react'
import Video from "../../components/sections/VideoSection"
import { graphql } from "gatsby"

export default ({primary}) => {
  
  return (
    <Video url={primary?.url} />
  )
}

export const query = graphql`
    fragment Video on PrismicPageDataBodyVideo {
        slice_label
        slice_type
        __typename
        primary{
            url
        }
    }
`
